import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useBrainEmbassyAnalytics } from "./brain-embassy_analytics";
import {
  partnerConfig,
  testimonials,
  generalInfoPL,
  generalInfoEN,
} from "./brain-embassy_partner_config";

const Theme = lazyWithRetry(() => import("./brain-embassy_theme"));

const faqsEN = [
  {
    question: "What's included with my multi pass?",
    answer:
      "With a multi pass, you will enjoy all the unique benefits of the Brain Embassy gathered in one open space: quality & ergonomic furniture, activity based design, vivid & dynamic Community, diverse events and professional business support.",
  },
  {
    question: "Is there somewhere I can make a call or have a meeting?",
    answer:
      "Phone booths are available to make calls as well as conference rooms to host meetings.",
  },
  {
    question: "Can I cancel my multi pass order?",
    answer:
      "You not cancel your multi pass order. However, you can always modify the date of your reservation 24 hours before your booking begins.",
  },
  {
    question: "When does my multi pass order expire?",
    answer: "You multi pass will expire 30 days after date of purchase.",
  },
];

const faqsPL = [
  {
    question: "Co zawiera mój karnet wielorazowego dostępu do Brain Embassy?",
    answer:
      "W ramach karnetu możesz korzystać ze wszystkich wyjątkowych zalet Brain Embassy: wysokiej jakości i ergonomiczne meble, możliwość elastycznego wyboru miejsca i pozycji pracy, dynamiczna społeczność, różnorodne wydarzenia i profesjonalne wsparcie biznesowe.",
  },
  {
    question:
      "Czy są u Was miejsca do zorganizowania rozmowy telefonicznej lub spotkania?",
    answer:
      "Dostępne są budki telefoniczne do wykonywania połączeń telefonicznych, a także sale spotkań.",
  },
  {
    question:
      "Czy mogę anulować moje zamówienie karnetu wielorazowego wejścia?",
    answer:
      "Niestety, nie możesz anulować zamówienia karnetu wielokrotnego wejścia. Zawsze możesz zmienić datę rezerwacji na 24 godziny przed jej rozpoczęciem.",
  },
  {
    question: "Kiedy wygasa moje zamówienie karnetu wielokrotonego wejścia?",
    answer:
      "Karnet wielokrotnego wejścia wygaśnie po 30 dniach od daty zakupu.",
  },
];

export function OfferingBrainEmbassyMultiPass() {
  useBrainEmbassyAnalytics();
  const { locale } = useI18n();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          title:
            locale.baseLanguageTag === "pl"
              ? "Wielorazowy dostęp do przestrzeni"
              : "Multi Pass",
          testimonials: testimonials,
          faqs: locale.baseLanguageTag === "pl" ? faqsPL : faqsEN,
          generalInfo:
            locale.baseLanguageTag === "pl" ? generalInfoPL : generalInfoEN,
        }}
      />
    </Fragment>
  );
}
